import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';
interface AdminActiveGunState {
  excludedFilter: string[];
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}

const defaultColumnList = [
  {
    name: 'created_at',
    label_key: 'submission',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 1,
  },
  {
    name: 'guns_for_sale',
    label_key: 'guns_for_sale',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: false,

    order: 2,
  },
  {
    name: 'mfg',
    label_key: 'mfg',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 3,
  },
  {
    name: 'product_specs',
    label_key: 'product_specs',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 4,
  },
  {
    name: 'price',
    label_key: 'asking_price',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 5,
  },
  {
    name: 'seller',
    label_key: 'seller',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 6,
  },

  {
    name: 'view',
    label_key: 'views',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 7,
  },
  {
    name: 'status',
    label_key: 'status',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'select',
    filter_placeholder: 'status_all',
    selectKey: 'gun_for_sale_status',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 8,
  },
  {
    name: 'category',
    label_key: 'category',
    allow_list: false,
    allow_filter: true,
    show_list_checkbox: false,
    show_filter_checkbox: true,
    type: 'asyncselect',
    filter_placeholder: 'category_all',
    asyncKey: 'productCategories',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 9,
  },
  {
    name: 'caliber',
    label_key: 'caliber',
    allow_list: false,
    allow_filter: true,
    show_list_checkbox: false,
    show_filter_checkbox: true,
    type: 'asyncselect',
    filter_placeholder: 'caliber_all',
    asyncKey: 'caliber',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 10,
  },
];

const exportColumnList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));

const initialState: AdminActiveGunState = {
  excludedFilter: ['search'],
  filterData: { sold_date: null },
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminActiveGunSlice = createSlice({
  name: 'adminActiveGun',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setActiveGunTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      state.tableColumnList = action.payload;
    },
  },
});

export const { setFilterData, resetFilterData, setReloadTableData, setActiveGunTableColumnList } =
  adminActiveGunSlice.actions;

export default adminActiveGunSlice.reducer;
